import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'currencySymbol'
})
export class CurrencySymbolPipe implements PipeTransform {

    private currencySymbols: { [key: string]: string } = {
        'AED': 'د.إ',
        'AFN': '؋',
        'ALL': 'L',
        'AMD': '֏',
        'ANG': 'ƒ',
        'AOA': 'Kz',
        'ARS': '$',
        'AUD': 'A$',
        'AWG': 'ƒ',
        'AZN': '₼',
        'BAM': 'KM',
        'BBD': '$',
        'BDT': '৳',
        'BGN': 'лв',
        'BHD': '.د.ب',
        'BIF': 'FBu',
        'BMD': '$',
        'BND': '$',
        'BOB': 'Bs.',
        'BRL': 'R$',
        'BSD': '$',
        'BTN': 'Nu.',
        'BWP': 'P',
        'BYN': 'Br',
        'BZD': '$',
        'CAD': 'C$',
        'CDF': 'FC',
        'CHF': 'CHF',
        'CLP': '$',
        'CNY': '¥',
        'COP': '$',
        'CRC': '₡',
        'CUC': '$',
        'CUP': '$',
        'CVE': '$',
        'CZK': 'Kč',
        'DJF': 'Fdj',
        'DKK': 'kr',
        'DOP': '$',
        'DZD': 'د.ج',
        'EGP': '£',
        'ERN': 'Nfk',
        'ETB': 'Br',
        'EUR': '€',
        'FJD': '$',
        'FKP': '£',
        'FOK': 'kr',
        'GBP': '£',
        'GEL': '₾',
        'GGP': '£',
        'GHS': '₵',
        'GIP': '£',
        'GMD': 'D',
        'GNF': 'FG',
        'GTQ': 'Q',
        'GYD': '$',
        'HKD': '$',
        'HNL': 'L',
        'HRK': 'kn',
        'HTG': 'G',
        'HUF': 'Ft',
        'IDR': 'Rp',
        'ILS': '₪',
        'IMP': '£',
        'INR': '₹',
        'IQD': 'ع.د',
        'IRR': '﷼',
        'ISK': 'kr',
        'JEP': '£',
        'JMD': '$',
        'JOD': 'د.ا',
        'JPY': '¥',
        'KES': 'Sh',
        'KGS': 'лв',
        'KHR': '៛',
        'KID': '$',
        'KMF': 'CF',
        'KRW': '₩',
        'KWD': 'د.ك',
        'KYD': '$',
        'KZT': '₸',
        'LAK': '₭',
        'LBP': 'ل.ل',
        'LKR': 'Rs',
        'LRD': '$',
        'LSL': 'M',
        'LYD': 'ل.د',
        'MAD': 'د.م.',
        'MDL': 'L',
        'MGA': 'Ar',
        'MKD': 'ден',
        'MMK': 'K',
        'MNT': '₮',
        'MOP': 'MOP$',
        'MRU': 'UM',
        'MUR': '₨',
        'MVR': 'Rf',
        'MWK': 'MK',
        'MXN': '$',
        'MYR': 'RM',
        'MZN': 'MT',
        'NAD': '$',
        'NGN': '₦',
        'NIO': 'C$',
        'NOK': 'kr',
        'NPR': '₨',
        'NZD': '$',
        'OMR': 'ر.ع.',
        'PAB': 'B/.',
        'PEN': 'S/',
        'PGK': 'K',
        'PHP': '₱',
        'PKR': '₨',
        'PLN': 'zł',
        'PYG': '₲',
        'QAR': 'ر.ق',
        'RON': 'lei',
        'RSD': 'дин',
        'RUB': '₽',
        'RWF': 'FRw',
        'SAR': '﷼',
        'SBD': '$',
        'SCR': '₨',
        'SDG': '£',
        'SEK': 'kr',
        'SGD': '$',
        'SHP': '£',
        'SLL': 'Le',
        'SOS': 'Sh',
        'SRD': '$',
        'SSP': '£',
        'STN': 'Db',
        'SYP': '£',
        'SZL': 'E',
        'THB': '฿',
        'TJS': 'ЅM',
        'TMT': 'm',
        'TND': 'د.ت',
        'TOP': 'T$',
        'TRY': '₺',
        'TTD': '$',
        'TVD': '$',
        'TWD': 'NT$',
        'TZS': 'Sh',
        'UAH': '₴',
        'UGX': 'Sh',
        'USD': '$',
        'UYU': '$U',
        'UZS': 'лв',
        'VES': 'Bs.',
        'VND': '₫',
        'VUV': 'VT',
        'WST': 'T',
        'XAF': 'FCFA',
        'XCD': '$',
        'XDR': 'SDR',
        'XOF': 'CFA',
        'XPF': '₣',
        'YER': '﷼',
        'ZAR': 'R',
        'ZMW': 'ZK',
        'ZWL': '$'
      };

  transform(value: string): string {
    return this.currencySymbols[value] || value;
  }

}